import React, { useState } from "react"
import { Card, Tab, Tabs } from "react-bootstrap"
import PageTitleButton from "../../../components/PageTitleButton"
import PrivacyPolicy from "./PrivacyPolicy"
import TermsAndCondition from "./TermsAndCondition"

const ContentManagement = () => {
  const [currentTab, setCurrentTab] = useState("terms")
  return (
    <>
      <PageTitleButton PagetitleText={"Content Management"} />
      <Card>
        <Card.Body>
          <Tabs defaultActiveKey="terms" onSelect={(tab) => setCurrentTab(tab)}>
            <Tab eventKey="terms" title="Terms and Condition">
              <TermsAndCondition
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
              />
            </Tab>
            <Tab eventKey="privacy" title="Privacy Policy">
              <PrivacyPolicy
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
              />
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </>
  )
}

export default ContentManagement
